<template>
    <div v-html="html"></div>
</template>
<script>
    import axios from 'axios';

    export default {
        props: ['url'],
        data: function () {
            return {
                html: '',
                loaded: false,
            }
        },
        methods: {
            getHtml() {
                const vm = this;
                vm.loaded = true;
                axios.get(vm.url).then(r => {
                    vm.html = r.data;
                });
            },
            scrolled() {
                let e = document.scrollingElement;
                if (!this.loaded && e.scrollTop + e.clientHeight + 300 >= this.$el.offsetTop) {
                    this.getHtml();
                }
            },
        },
        created() {
            document.addEventListener('scroll', this.scrolled);
        }
    }
</script>